import classNames from "classnames";
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

import waterledgerLogo from "@images/waterledgerLogo.svg";
import AppNavigation from "@components/layout/zenith/AppNavigation";
import UserAvatar from "@components/layout/zenith/UserAvatar";
import { useAppContext } from "@context/AppContext";

const AppSidebar = () => {
  const { t } = useTranslation();
  const { loggedInInfo, isExpandSidebar, setIsExpandSidebar } = useAppContext();

  return (
    <aside
      data-testid="zenith-sidebar"
      className={classNames(
        "fixed top-14 bottom-0 left-0 z-20 hidden flex-col border-r border-gray-200 bg-white transition-all duration-200 lg:flex",
        isExpandSidebar ? "w-56" : "w-14",
      )}
    >
      <div
        className={classNames(
          "flex items-center gap-2.5 border-b border-gray-200 py-3.5",
          isExpandSidebar ? "px-4" : "flex-col px-2",
        )}
      >
        <UserAvatar name={loggedInInfo?.userDetails?.name} />
        {isExpandSidebar ? (
          <div className="min-w-0">
            <p className="truncate text-sm font-bold text-gray-900">
              {loggedInInfo?.userDetails?.name}
            </p>
            <p className="text-xs text-gray-500">
              {loggedInInfo?.userDetails?.subscriber?.accountNumber}
            </p>
          </div>
        ) : null}
        <button
          type="button"
          aria-label={t("zenith.navigation.toggle_sidebar") as string}
          aria-expanded={isExpandSidebar}
          className={classNames(
            "shrink-0 rounded p-0.5 text-gray-500 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-1",
            { "ml-auto": isExpandSidebar },
          )}
          onClick={() => {
            setIsExpandSidebar((isExpand: boolean) => !isExpand);
          }}
        >
          {isExpandSidebar ? (
            <ChevronDoubleLeftIcon className="h-4 w-4" aria-hidden="true" />
          ) : (
            <ChevronDoubleRightIcon className="h-4 w-4" aria-hidden="true" />
          )}
        </button>
      </div>

      <div className="flex-1 overflow-y-auto overflow-x-hidden px-2 py-3">
        <AppNavigation />
      </div>

      {isExpandSidebar ? (
        <div className="flex items-center gap-2 border-t border-gray-200 px-4 py-3 text-xxs text-gray-500">
          {t("common.powered_by")}
          <img src={waterledgerLogo} alt="Water Ledger" className="h-4" />
        </div>
      ) : null}
    </aside>
  );
};

export default AppSidebar;
